import React from "react";
import SEO from "../components/SEO";

const Meetup = () => {
  return (
    <div style={{ width: "100vw", height: "100vh", margin: 0, padding: 0 }}>
      <SEO
        title="Community IT Meetup Registration | Shift IT"
        description="Register for the Shift IT community meetup. Connect, learn, and discuss Microsoft 365, Azure, automation, and modern workplace practices."
        canonical="https://shift-it.io/meetup"
      />
      <iframe
        title="ITmeetup"
        src="https://forms.microsoft.com/r/SMRDan6rkw?embed=true"
        frameBorder="0"
        marginWidth="0"
        marginHeight="0"
        style={{
          border: "none",
          width: "100vw",
          height: "100vh",
          minHeight: "100%",
          minWidth: "100%",
          display: "block",
        }}
        allowFullScreen
        webkitallowfullscreen
        mozallowfullscreen
        msallowfullscreen
      />
    </div>
  );
};

export default Meetup;
